import { render, staticRenderFns } from "./LogoPayloadView.vue?vue&type=template&id=28493026&scoped=true&"
import script from "./LogoPayloadView.vue?vue&type=script&lang=ts&"
export * from "./LogoPayloadView.vue?vue&type=script&lang=ts&"
import style0 from "./LogoPayloadView.vue?vue&type=style&index=0&id=28493026&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28493026",
  null
  
)

export default component.exports